
import { defineComponent, computed } from 'vue'
import { useRoute } from 'vue-router'
import MenuMobile from '@/components/Menu/mobile.vue'
import HeaderNav from '@/components/HeaderNav/index.vue'
import { Container, Footer } from '@/components/MobileLayout'
import { tabbarList, tabbarRoutes } from './mobileTabbarListConfig'
import useLayout from './useLayout'

export default defineComponent({
  name: 'LayoutMobileComp',

  components: { HeaderNav, MenuMobile, Container, Footer },

  data() {
    return {
      tabbarList,
      tabbarRoutes
    }
  },

  setup() {
    const route = useRoute()
    const { isFullscreen, isAsideCollapsed, handleCollapseStatusChange } = useLayout()

    const showTabbar = computed(() => {
      // 支持正则方式进行精确匹配（默认结尾加 $）
      return tabbarRoutes.some((routeRule: string) => new RegExp(`^${routeRule}$`).test(route.path))
    })

    return {
      showTabbar,
      isFullscreen,
      isAsideCollapsed,
      handleCollapseStatusChange
    }
  }
})
